<template ref="adminUser">
  <div>
      <header-admin-pages
        title="Партнеры"
        :counter="$store.getters.getPartners.length"
        :button="{ title: 'Добавить партнера', link: '/admin/partners/create?type=create' }"
      />
      <form @submit.prevent="submitFilter" @reset="resetFilter"  class="filters">
        <input  v-model="filers.name"  placeholder='Ввдетие название страны' type="text" class="input blue">
        <div class="wrapper-btn-filters">
          <input  class="filters-reset" type="reset" value="Сбросить фильтры">
          <input class="btn-blue" type="submit" value="Найти">
        </div>
      </form>
      <main>
        <table>
          <tr>
            <td><p>Дата подписания</p></td>
            <td><p>Ссылка на документ</p></td>
            <td class="drop-icon"></td>
          </tr>
          <tr v-for="item in $store.getters.getPartners" :key="`country${item.id}`">
            <td><p>{{ item.signing }}</p></td>
            <td><a :href="`${$store.getters.getUrlApi}${item.document.url}`" target="_blank">Ссылка на докумет</a></td>
            <td class="drop-icon">
              <drop-list @clickItem="clickItem" :idItem="item.id"/>
            </td>
          </tr>
        </table>
        <pagination/>
      </main>
  </div>
</template>

<script>
import HeaderAdminPages from '@/components/Admin/HeaderAdminPages'
import Pagination from '@/components/Pagination'
import DropList from '@/components/Admin/DropList'
export default {
  name: 'Partners',
  data () {
    return {
      filers: {
        name: ''
      }
    }
  },
  methods: {
    clickItem (value) {
      if (value.value === 'del') {
        const consent = confirm('Вы уверены, чтобы хотите удалить пользователя ?')
        if (consent) {
          this.$store.dispatch('deletePartners', value.id)
        } else {
          this.$noty.warning('Удаление отменено')
        }
      } else {
        this.$store.dispatch('setDetailPartners', value.id)
      }
    },
    submitFilter () {
      this.$store.dispatch('setFilterPartners', this.filers.name)
    },
    resetFilter () {
      this.$store.dispatch('setPolls')
      this.filers.title = ''
    }
  },
  mounted () {
    this.$store.dispatch('setPartners')
  },
  components: {
    HeaderAdminPages,
    Pagination,
    DropList
  }
}
</script>

<style scoped lang="scss">
.filters{
  margin-top: 1.37rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px solid #D5D6D9;
}
.input{
  width: 32%;
  margin-bottom: 1.25rem;
}
.filters-reset {
  background: none;
  font-size: 0.75rem;
  color: #003E78;
  opacity: 0.6;
  margin-right: 1.37rem;
  cursor: pointer;
}
table{
  margin-top: 2rem;
  border-spacing: 0;
  border-collapse: collapse;

  tr{
    padding: 0;
    border-bottom: 1px solid #D5D6D9;
  }
}
td {
  max-width: 23%;
}
tr {
  p {
    font-size: 0.812rem;
    line-height: 154%;
    color: #5E686C;
  }
}
tr {
  a {
    font-size: 0.812rem;
    line-height: 154%;
    color: #246CB7;
  }
}
.drop-icon {
  width: 3rem;
}
</style>
